L.mapbox.accessToken = 'pk.eyJ1IjoiY2xhc3NpY2NvdHRhZ2VzIiwiYSI6ImNqMTNldmR5NDAwMGsycXJteG41aGxpb3MifQ.vgda8-nICmOzUiGEd6Quqw';

var map = null,
markers = [],
markerClusterer = null,
locationPolygons = [],
markerImage = L.icon({
    iconUrl: '/images/maps/marker-available.png',
    //iconSize: [24, 32],
	iconSize: [30, 48],
	iconAnchor: [15, 48],
    popupAnchor: [0, -24]
}),
/** Not available marker image **/
NAmarkerImage = L.icon({
	iconUrl: '/images/maps/marker-unavailable.png',
	iconSize: [24, 32],
	iconAnchor: [12, 30],
	popupAnchor: [0, -15]
}),
officeMarkerImage = L.icon({
	iconUrl: '/images/maps/office.png',
	iconSize: [30, 40],
	iconAnchor: [15, 38],
	popupAnchor: [0, -36]
}),
options = {
	zoom: 9,
	maxZoom: 18,
	center: [50.27112210676994, -5.428127500585897],
	scrollWheelZoom: false
};

//Set up the map
function loadTheMap() {
    if (map != null) return;
    if (document.getElementById("map") == null) return;

    map = L.mapbox.map(document.getElementById("map"), null, options);
    
    L.control.layers({
        'Streets': L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            tileSize: 256,
            minZoom: 1,
            attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            crossOrigin: true
        }).addTo(map),
        'Satellite': L.mapbox.styleLayer('mapbox://styles/mapbox/satellite-streets-v10')
    }, {
        'Offices': officeMarkers().addTo(map)
    }).addTo(map);

    // popup event to load image stored as data attribute
    map.on('popupopen', function (e) {
        var content = e.popup.getContent();
        var $el = $('<div>').append(content);
        $el.find('img[data-src]').each(function () {
            $(this).attr('src', $(this).attr('data-src'));
        });
        e.popup.setContent($el.html());
    });

    
    if ($('.property-tab-mapview').length != 0) {

        marker = L.marker([property.data.lat, property.data.lon], {
            icon: markerImage,
            data: property.data
        }).addTo(map).bindPopup(buildPopup(property.data), { autoPanPadding: L.point(20, 20) });

        map.setView([property.data.lat, property.data.lon], 12);

    }
    else { // Get all properties
        $("#map-loading").show();
        $.ajax({ url: "/feeds/mapFeed.aspx", dataType: "xml" })
		.success(function (result) {
			var properties = $(result).find("properties:first");
			properties.find("property").each(function (index, value) {
			    var property = {
			        "id": $(value).attr("id"),
                    "property_code": $(value).attr("property_code"),
                    "property_isComplex": $(value).attr("property_isComplex"),
                    "name": $(value).attr("name"),
			        "location": $(value).attr("location"),
			        "url": $(value).attr("url"),
			        "bedrooms": $(value).attr("bedrooms"),
			        "sleeps": $(value).attr("sleeps"),
			        "lat": $(value).attr("lat"),
			        "lon": $(value).attr("lon"),
			        "image": $(value).attr("image"),
                    "available": $(value).attr("available")

			    };
			    if (markerClusterer) markerClusterer.clearLayers();

                if (property.property_isComplex === "False") {
                    marker = L.marker([property.lat, property.lon], {
                        icon: markerImage,
                        data: property,
                        title: property.name
                    });
                    marker.bindPopup(buildPopup(property));
                    markers.push(marker);
                }
			
			});
			updateMarkersForSearch();
		})
		.error(function () {
			//console.log('Properties unavailable');
		})
		.complete(function () {
			//console.log('Properties download complete')
		});
    }
}
window.loadTheMap = loadTheMap;
function officeMarkers() {
	 contactMarkers = [
		{
			lat:50.19439960000001,
			lng:-5.393953600000023,
             data:'<h3>Hayle Office</h3>Sapphire House,<br/>Unit 14 Hayle Business Park,<br/>Hayle,<br/>Cornwall<br/>TR27 5JR'
		},
		{
			lat:50.215258000000006,
			lng:-5.477779999999958,
			data:'<h3>Wharf Office</h3>St Ives,<br/>The Wharf,<br/>St Ives,<br/>Cornwall<br/>TR26 1PU'
		},
		{
			lat:50.21681610353775,
			lng:-5.47856345326694,
			data: '<h3>St Ives Office</h3>St. Nicholas Court,<br/>‘The Island’,<br/>St Ives,<br/>Cornwall<br/>TR27 1SZ'
        },
		{
		    lat: 50.120968,
		    lng: -5.533660,
		    data: '<h3>Penzance Office</h3>4 Albert Street,<br/>Penzance,<br/>Cornwall<br/>TR18 2LR'
		},
		{
            lat: 50.345203,
            lng: -5.151880,
            data: '<h3>Perranporth Office</h3>Chi Hwel Leysour, Wheal Leisure,<br/>Perranporth,<br/>Cornwall<br/>TR6 0EY'
		},
		{
		    lat: 50.834904,
		    lng: -4.542365,
		    data: '<h3>Bude Office</h3>2 Flexbury Park,<br/>Bude,<br/>Cornwall<br/>EX23 8RS'
		},
		{
		    lat: 50.270279,
		    lng: -4.787940,
		    data: '<h3>Mevagissey Office</h3>10 Market Square,<br/>Mevagissey,<br/>Saint Austell,<br/>Cornwall<br/>PL26 6UD'
         },
         {
             lat: 50.085722,
             lng: -5.315452,
             data: '<h3>Porthleven Office</h3>Fore Street,<br/>Porthleven,<br/>Cornwall<br/>TR13 9HJ'
         }
	];

	var officeLayer = L.layerGroup();

	$.each(contactMarkers, function (index, value) {
        marker = L.marker([value.lat, value.lng], {
			icon: officeMarkerImage,
			data: value,
            zIndexOffset:-100
		}).addTo(officeLayer);
		marker.bindPopup('<div class="popup-office">'+ value.data + '</div>');
    });

    return officeLayer;
}


var updateMarkersForSearchXHR, updateMarkersForSearchCounter = 0;

var mapBounds = null;

function updateMarkersForSearch(url) {
    $("#map-loading").show();
    mapFeedUrl = window.location.protocol + '//' + window.location.host + "/feeds/mapFeed.aspx";
    if (typeof url === 'undefined') url = window.location.pathname;
    if (url.indexOf("shortlist") === -1) {
        var type = url.split('/')[1];
        var re = new RegExp('^\/' + type);
        var search = url.replace(re, '');
        mapFeedUrl = mapFeedUrl + "?type=" + type + "&search=" + search;
    }
    else {

        mapFeedUrl = mapFeedUrl + '?shortlist=true';

        var codes = $('.shortlist-share').attr('data-cottagecodes');
        if (typeof codes !== 'undefined') {
            mapFeedUrl = mapFeedUrl + '&codes=' + codes;
        } 
    }

    if (updateMarkersForSearchXHR) {
        updateMarkersForSearchXHR.abort();
    }

    var updateMarkersForSearchToken = ++updateMarkersForSearchCounter;

    updateMarkersForSearchXHR = $.get(mapFeedUrl, function (data) {

        if (updateMarkersForSearchToken !== updateMarkersForSearchCounter) return;

        mapBounds = null;

        //set polygon
        var polygonString = $(data).find("polygons").attr("string");
        loadPolygonsFromString(polygonString);



        //set marker visibility
        var propertyIds = [];
        $(data).find("properties:first").find("property").each(function (index, value) {
            propertyIds.push($(value).attr("id"));
        });
        $.each(markers, function (index, marker) {
            if (typeof (marker.options.data) != 'undefined') {
                if ($.inArray(marker.options.data.id, propertyIds) != -1) {
                    setAvailable(index);
                } else {
                    setNotAvailable(index);
                }
            }
        });

        if (markerClusterer) markerClusterer.clearLayers();

        var visibleMarkers = [];

        $.each(markers, function (index, marker) {
            if (typeof (marker.options.data) != 'undefined') {
                if (marker.options.data.available == true) {
                    visibleMarkers.push(marker);
                }
            }
        });


        markerClusterer = L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 30,
            spiderLegPolylineOptions: { weight: 3, color: '#5DBDCB', opacity: 1 },
            spiderfyDistanceMultiplier: 2
        }).addTo(map);


        if (visibleMarkers.length > 0) {
            $.each(visibleMarkers, function (index, marker) {
                if (typeof (marker.getLatLng()) != 'undefined') {
                    if (mapBounds == null) mapBounds = L.latLngBounds([marker.getLatLng()]);
                    else mapBounds.extend(marker.getLatLng());

                    markerClusterer.addLayer(marker);
                }
            });

        }

        if (mapBounds != null && mapBounds.isValid()) { // if bounds arent empty use them!
            map.once('moveend', function () {
                if (map.getZoom() > 16) map.setZoom(16);
            });
            map.fitBounds(mapBounds);
        }


        $("#map-loading").hide();

    }, "xml");
}
window.updateMarkersForSearch = updateMarkersForSearch;
function buildPopup(property) {
    var template = $('#property-overlay #content-template').clone();
    $(template).removeAttr('id').removeClass('hidden').addClass('popup-single');

    


        if (property.image != undefined) {
            $(template).find('img').attr('data-src', property.image);
        } else {
            $(template).find('img').css('display', 'none');
        }

        $(template).find('.property-name a').html(property.name);
        $(template).find('.property-name a').attr('href', property.url);

        $(template).find('h4.location').html(property.location);

        $(template).find('.sleeps span').html(property.sleeps);
        // $(template).find('.price-band span').html(value.data.price_band);
        $(template).find('.property-code span').html(property.property_code);


        if (property.bedrooms != 0) {
            $(template).find('.bedrooms span').html(property.bedrooms);
        } else {
            $(template).find('.bedrooms').css('display', 'none');
        }
  

    
    return $('<div>').append(template).html();
}

function addOverlay(properties) {
	
	removeOverlay();
	infoWindow.close();

	propertyCount = properties.length;
	showOverlay = true;

	if ( propertyCount == 1 ) {
		//Only one property so show the overlay
		className = 'single';
		map.panTo(new google.maps.LatLng(properties[0].data.lat, properties[0].data.lon));
	} else if ( propertyCount > 1 && map.getZoom() >= 18 ) {
		//Multiple properties so only show overlay if it's at full zoom.
		if (propertyCount <= 3) {
			className = 'max-three';
		} else if (propertyCount <= 6) {
			className = 'max-six';
		} else if (propertyCount <= 12) {
			className = 'max-twelve';
		} else if (propertyCount <= 18) {
			className = 'max-eighteen';
		} else {
			className = 'infinite';
		}
	} else {
		showOverlay = false;
	}

	if (showOverlay) {
		var overlay = $('#property-overlay').clone();
		$(overlay)
			.removeAttr('id')
			.attr('id', 'property-overlay-clone')
			.addClass(className);

		$.each(properties, function(index, value){
			template = $(overlay).find('#content-template').clone();
			$(template).removeAttr('id').removeClass('hidden');
			
			if (value.data.image != undefined){
				$(template).find('img').attr('src', value.data.image);
			} else {
				$(template).find('img').css('display', 'none');
			}

			$(template).find('.property-name a').html(value.data.name);
			$(template).find('.property-name a').attr('href', value.data.url);

			$(template).find('h4.location').html(value.data.location);
			
			$(template).find('.sleeps span').html(value.data.sleeps);
			// $(template).find('.price-band span').html(value.data.price_band);
			$(template).find('.property-code span').html(value.data.property_code);
			$(template).find('.bedrooms span').html(value.data.bedrooms);
			$(overlay).append(template);

		});
		$(overlay).find('#content-template').remove();
	}

	$(overlay).appendTo('#map');
}


function removeOverlay() {
	$('#property-overlay-clone').remove();
}

function setAvailable(index) {
	markers[index].setIcon(markerImage);
    markers[index].options.data.available = true;
}

function setNotAvailable(index) {
    markers[index].setIcon(NAmarkerImage);
	markers[index].options.data.available = false;
}

function loadPolygonsFromString(string) {
    //remove old polygons
    for (i = 0; i < locationPolygons.length; i++) {
        if(map.hasLayer(locationPolygons[i])) map.removeLayer(locationPolygons[i]);
        locationPolygons[i] = null;
    }
    locationPolygons = [];

    if (string.length > 0) {
        var shapes = string.split("; ");
        for (i = 0; i < shapes.length; i++) {
            var shape = shapes[i];
            if (shape != "") {
                var parameters = shape.match(/([A-Z ]+)\([\(]?([0-9-. ,]+)\)[\)]?/);
                if (parameters) {
                    var coords = [];
                    var lls = parameters[2].split(",");
                    for (j = 0; j < lls.length; j++) {
                        var ll = $.trim(lls[j]);
                        var llarr = ll.split(" ");
                        var gll = L.latLng(llarr[1], llarr[0]);
                        coords.push(gll);
                        if (mapBounds == null) mapBounds = L.latLngBounds(gll);
                        else mapBounds.extend(gll);
                    }


                    locationPolygons.push(L.polyline(coords,{
                        weight: 3,
                        color: "#9BCB5D",
                        opacity: 1,
                        fillColor: '#9BCB5D',
                        fillOpacity: 0.5
                    }).addTo(map));
                }
            }
        }
    }
}